export const TOKEN_LOGO_S3_BUCKET_NAME = 'icecreamswap-assets'